import React from 'react';
import { useChatbotInitialMessage } from '../../hooks';
import { useCurrentScreen } from '../../hooks/useCurrentScreen';
import { OnuScreens } from '../../types';
import BotAvatar from './BotAvatar';
import BotChatMessage from './BotChatMessage';
import ChatbotLinks from './ChatbotLinks';
import ChatbotWithSession from './ChatbotWithSession';
import { GPTContainer } from './FullGPT.styles';
import UserAvatar from './UserAvatar';
import { UserChatMessage } from './UserChatMessage';
import config from './config';

const FullGPT = () => {
	const screen = useCurrentScreen() ?? OnuScreens.DASHBOARD;
	const initialMessage = useChatbotInitialMessage(screen);
	return (
		<GPTContainer>
			<ChatbotWithSession
				config={config(initialMessage, screen, {
					header: () => <></>,
					botAvatar: BotAvatar,
					userAvatar: UserAvatar,
					botChatMessage: BotChatMessage,
					userChatMessage: UserChatMessage,
				})}
			/>
			<ChatbotLinks />
		</GPTContainer>
	);
};

export default FullGPT;
